import React from 'react'

function ChartsHeader() {
  return (
    <div>
      ChartsHeader
    </div>
  )
}

export default ChartsHeader
